import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Auth.css';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const user = await login(form.email, form.password);
      if (user.role === 'admin') navigate('/admin');
      else if (user.role === 'instructor') navigate('/instructor');
      else navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-branding">
        <div className="auth-branding-inner">
          <div className="auth-logo"><img src="/wf-logo.png" alt="Wow Factor Baseball" style={{width:"192px",height:"192px",objectFit:"contain"}} /></div>
          <h1 className="auth-brand-name">WOW FACTOR</h1>
          <p className="auth-brand-sub">Baseball Training & Development</p>
          <div className="auth-brand-divider" />
          <p className="auth-brand-quote">Built different.<br />Train with purpose.</p>
        </div>
      </div>
      <div className="auth-form-panel">
        <img src="/wf-logo.png" alt="" className="auth-bg-logo" aria-hidden="true" />
        <div className="auth-form-container">
          <div className="auth-mobile-header">
            <img src="/wf-logo.png" alt="Wow Factor Baseball" className="auth-mobile-logo" />
            <span className="auth-mobile-brand">WOW FACTOR</span>
            <span className="auth-mobile-brand-sub">Baseball Training & Development</span>
          </div>
          <div className="auth-form-header">
            <h2>Welcome back</h2>
            <p>Sign in to your account</p>
          </div>
          <form onSubmit={handleSubmit} className="auth-form">
            {error && <div className="auth-error-banner"><span>⚠</span> {error}</div>}
            <div className="form-group">
              <label className="form-label" htmlFor="email">Email Address</label>
              <input id="email" name="email" type="email" className={`form-input ${error ? 'error' : ''}`} placeholder="you@example.com" value={form.email} onChange={handleChange} required autoComplete="email" />
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="password">Password</label>
              <input id="password" name="password" type="password" className={`form-input ${error ? 'error' : ''}`} placeholder="••••••••" value={form.password} onChange={handleChange} required autoComplete="current-password" />
            </div>
            <button type="submit" className="btn btn-primary btn-lg auth-submit-btn" disabled={loading}>
              {loading ? <span className="auth-spinner" /> : 'Sign In'}
            </button>
          </form>
          <div className="auth-form-footer">
            <p><Link to="/forgot-password" className="auth-link">Forgot your password?</Link></p>
            <p style={{marginTop:'8px'}}>Don't have an account? <Link to="/register" className="auth-link">Create one</Link></p>
          </div>
          <div className="auth-help-banner">
            <span>📖</span>
            <span>New to Wow Factor? <a href="/help/parent" target="_blank" rel="noopener noreferrer" className="auth-link">View the Getting Started Guide</a></span>
          </div>
        </div>
      </div>
    </div>
  );
}
